import { GalleryState } from 'editor/src/store/gallery/types';

import getUploadInsertIndex from './getUploadInsertIndex';

// The host swaps a split PDF for its pages, so the pages take the PDF's place in its upload batch and stay in
// file-name order with the files around it. Pages listed before this went on top, so they move into place too.
const putPdfPagesInUploadOrder = (state: GalleryState, uploaderId: string, pageImageIds: string[]) => {
  const batchIndex = state.uploadBatches?.findIndex((ids) => ids.includes(uploaderId)) ?? -1;
  if (!state.uploadBatches || batchIndex === -1 || !pageImageIds.length) {
    return;
  }

  const batch = state.uploadBatches[batchIndex];
  const pdfIndex = batch.indexOf(uploaderId);
  state.uploadBatches[batchIndex] = [...batch.slice(0, pdfIndex), ...pageImageIds, ...batch.slice(pdfIndex + 1)];

  // Placing each page against pages still out of place would anchor it to them, so take them all out first.
  const pages = state.images.filter((image) => pageImageIds.includes(image.id));
  state.images = state.images.filter((image) => !pageImageIds.includes(image.id));
  pageImageIds.forEach((imageId) => {
    const page = pages.find((image) => image.id === imageId);
    if (page) {
      state.images.splice(getUploadInsertIndex(state, imageId), 0, page);
    }
  });
};

export default putPdfPagesInUploadOrder;
